import $ from 'jquery';
import store from './store';
import { createApp } from 'vue';
import intakeFormApp from './components/intake_form_app';

const ELEMENTS_SELECTORS = ['#header_intake_form_app', '#intake_form_app'];

export async function initIntakeFormApp() {
  for (const ELEMENT_SELECTOR of ELEMENTS_SELECTORS) {
    if ($(ELEMENT_SELECTOR).length) {
      const data = $(ELEMENT_SELECTOR).data();
      const imageUrl = data.settingsImageUrl,
        scholarPath = data.settingsScholarPath,
        isBannerLink = data.isBannerLink,
        profileCompleted = data.userInfoProfileCompleted;

      let userInfoMilitaryAffiliation = null,
        userInfoMilitaryAffiliationDetails = null;

      if (data.userInfoMilitaryAffiliation != null) {
        userInfoMilitaryAffiliation = data.userInfoMilitaryAffiliation ? 'true' : 'false';
      }

      if (data.userInfoMilitaryAffiliationDetails != null) {
        userInfoMilitaryAffiliationDetails = data.userInfoMilitaryAffiliationDetails;
      }

      const promises = [
        store.dispatch('loadDegreePrograms', data.settingsDegreePrograms),
        store.dispatch('loadMilitaryStatus', data.settingsMilitaryStatus),
        store.dispatch('loadRegions', data.settingsRegions),
        store.dispatch('loadDegreeOptions', data.settingsDegreeOptions),
        store.dispatch('loadCourseModality', data.settingsCourseModality),
        store.dispatch('loadSchoolSize', data.settingsSchoolSize),
        store.dispatch('loadHbcuOptions', data.settingsHbcuOptions),
        store.dispatch('loadUserDegreeType', data.userInfoUserDegreeType),
        store.dispatch('setUserSdnAgree', data.userInfoUserSdnAgree),
      ];

      if (data.userInfoUserSdnAgree) {
        const discountPromise = store.dispatch('setDiscountNumber');
        if (discountPromise) {
          promises.push(discountPromise);
        }
      }

      await Promise.all(promises);

      createApp(intakeFormApp, {
        imageUrl,
        scholarPath,
        isBannerLink,
        profileCompleted,
        userInfoMilitaryAffiliation,
        userInfoMilitaryAffiliationDetails,
      })
        .use(store)
        .mount(ELEMENT_SELECTOR);
    }
  }
}
